import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { fetchSuggestedTopics } from '@atlassian/jira-servicedesk-knowledge-common/src/services/fetch-suggested-topics/index.tsx';
import {
	FETCH_SUGGESTED_TOPICS,
	type FetchSuggestedTopicsAction,
} from '../../state/actions/fetch-suggested-topics/index.tsx';
import { fetchSuggestedTopicsFailure } from '../../state/actions/fetch-suggested-topics-failure/index.tsx';
import { fetchSuggestedTopicsSuccess } from '../../state/actions/fetch-suggested-topics-success/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>) =>
	action$.ofType(FETCH_SUGGESTED_TOPICS).mergeMap((action: FetchSuggestedTopicsAction) => {
		const { projectId, activationId } = action.payload;
		return Observable.fromPromise(fetchSuggestedTopics(projectId, activationId))
			.map((suggestedTopicsResp) => fetchSuggestedTopicsSuccess(suggestedTopicsResp))
			.catch((err) => Observable.of(fetchSuggestedTopicsFailure(err)));
	});
